import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoTiposLojas } from 'pages/compra/configuracao-pedido/types';

export function useQueryTiposLojas() {
    const { id } = useParams();
    const requestListagem = useRequestListagem();

    return useQuery<ConfigPedidoTiposLojas[]>({
        enabled: !id,
        queryKey: ['tipoLoja', id],
        queryFn: () =>
            requestListagem({
                url: '/gestao/tipoloja',
                sort: [{ property: 'dsTipoLoja', direction: 'ASC' }],
                columns: 'idTipoLoja,dsTipoLoja',
            }).then((res) => res.data.data),
        onError: () =>
            enqueueSnackbar('Ocorreu um erro ao carregar os tipos de lojas', {
                variant: 'error',
            }),
    });
}
